import {toast} from "react-toastify";
import toastOptions from "../data/ToastOptions";

export const truncateDecimals = (number, digits) => {
    let multiplier = Math.pow(10, digits);
    let adjustedNumber = number * multiplier;
    let truncatedNumber = Math.trunc(adjustedNumber) / multiplier;
    return truncatedNumber.toString();
}

export const copyToClipboard = async (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            toast.success('Text Copied.', {...toastOptions, toastId: 41});
        } catch (err) {
            fallbackCopy(text);
        }
    } else {
        fallbackCopy(text);
    }
};

const fallbackCopy = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    toast.success('Text Copied.', {...toastOptions, toastId: 40});
};

